import * as classnames from 'classnames'
import {composeTheme} from 'core/utils/theme-helpers'
import * as React from 'react'
import * as styles from './Expandable.css'

interface ITheme {
  container?: string
  childrenContainer?: string
  handleContainer?: string
}

type UncontrolledProps = {
  className?: string,
  children?: any,
  handle?: any,
  theme?: ITheme,
}
type Props = UncontrolledProps & {
  isOpen: boolean,
  onClickHandle: () => void,
}
type ComponentState = {
  isMoreAvailable: boolean,
}

const isElementOverflowed = (node: HTMLElement) => node.scrollHeight > node.clientHeight

export class UnthemedExpandable extends React.PureComponent<Props, ComponentState> {
  public state: ComponentState = {
    isMoreAvailable: false,
  }
  private childrenContainerRef: HTMLDivElement | null = null

  public render() {
    const {theme = {}} = this.props
    const childrenContainerStyles = {
      maxHeight: this.props.isOpen ? 'initial' : undefined,
    }

    return (
      <div className={classnames(theme.container, this.props.className)}>
        <div
          className={theme.childrenContainer}
          style={childrenContainerStyles}
          ref={this.setChildrenContainerRef}
        >
          {this.props.children}
        </div>
        <div
          className={theme.handleContainer}
          onClick={this.props.onClickHandle}
        >
          {this.state.isMoreAvailable && this.props.handle}
        </div>
      </div>
    )
  }

  public componentDidMount() {
    // WARNING: This does not cover certain scenarios such as:
    // - maxHeight is changed by the parent component WITHOUT a VDOM rebuild
    // - children changes (i.e. content being expanded is changed)
    // These are addressable scenarios, but is currently overkill since none of our use cases require that logic.
    if (isElementOverflowed(this.childrenContainerRef!)) {
      this.setState({
        isMoreAvailable: true,
      })
    }
  }

  private setChildrenContainerRef = (node: HTMLDivElement | null) => {
    this.childrenContainerRef = node
  }
}

export const Expandable = composeTheme<Props, {}, ITheme>(UnthemedExpandable, styles)

type UncontrolledComponentState = {
  isOpen: boolean,
}
export class UnthemedUncontrolledExpandable extends React.PureComponent<UncontrolledProps, UncontrolledComponentState> {
  public state = {
    isOpen: false,
  }

  public render() {
    return (
      <UnthemedExpandable
        isOpen={this.state.isOpen}
        onClickHandle={this.handleClick}
        {...this.props}
      />
    )
  }

  private handleClick = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    })
  }
}

export const UncontrolledExpandable =
  composeTheme<UncontrolledProps, {}, ITheme>(UnthemedUncontrolledExpandable, styles)



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/components/Expandable/Expandable.tsx